<div class="flex flex-col mt-3">
  <label class="soft-overline color-light mb-1">
    {{ '#CONNECTION_SETTINGS.SELECTED_CONNECTION' | translate }}
  </label>
  <soft-select
    class="border-primary"
    [value]="selectedConnection$ | async"
    (valueChange)="onSelectionChange($event)"
    #select
  >
    @for (connection of connections$ | async; track connection) {
      <soft-select-option [value]="connection">
        @if (connection.name) {
          <span class="font-semibold">{{ connection.name }}</span>
          <span class="color-light mr-2">
            (<span>{{ connection.host }}</span>
            @if (connection.port) {
              <span>:{{ connection.port }}</span>
            }
            @if (connection.basePath) {
              <span>{{ connection.basePath }}</span>
            }
            )
          </span>
        } @else {
          <span>{{ connection.host }}</span>
          @if (connection.port) {
            <span>:{{ connection.port }}</span>
          }
          @if (connection.basePath) {
            <span>{{ connection.basePath }}</span>
          }
        }
      </soft-select-option>
    }
  </soft-select>
</div>
<div
  (click)="onAdd()"
  class="border border-secondary h-8 pointer hover:bg-selected flex mt-4 justify-center items-center connection-actions"
>
  <div>
    <i class="fa-regular fa-plus"></i>
    {{ '#CONNECTION_SETTINGS.ADD' | translate }}
  </div>
</div>
<div class="flex mt-2">
  <div
    class="flex justify-center pointer w-full h-8 border border-secondary mr-1 items-center connection-actions"
    (click)="onEdit()"
  >
    <i class="fa-regular fa-pen-to-square mr-2"></i>
    {{ '#CONNECTION_SETTINGS.EDIT' | translate }}
  </div>
  <div
    class="flex justify-center pointer w-full h-8 text-danger border border-secondary ml-1 items-center connection-actions"
    (click)="onDelete()"
  >
    <i class="fa-regular fa-trash mr-2"></i>
    {{ '#CONNECTION_SETTINGS.DELETE' | translate }}
  </div>
</div>
<div class="mt-2">
  <hr class="soft-separator" />
</div>
<div
  (click)="onScan()"
  class="border border-primary p-2 pointer mt-3 hover:bg-selected flex bg-primary-50 text-primary justify-center connection-actions"
>
  <div>
    <i class="fa-regular fa-barcode-scan"></i>
    {{ '#CONNECTION_SETTINGS.SCAN' | translate }}
  </div>
</div>
